import { render, staticRenderFns } from "./ciic-table-column.vue?vue&type=template&id=a105021e&scoped=true&"
import script from "./ciic-table-column.vue?vue&type=script&lang=js&"
export * from "./ciic-table-column.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a105021e",
  null
  
)

export default component.exports